import { render, staticRenderFns } from "./PageCloudImportEditSettings.vue?vue&type=template&id=54f6ca0c&scoped=true&"
import script from "./PageCloudImportEditSettings.vue?vue&type=script&lang=js&"
export * from "./PageCloudImportEditSettings.vue?vue&type=script&lang=js&"
import style0 from "./PageCloudImportEditSettings.vue?vue&type=style&index=0&id=54f6ca0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f6ca0c",
  null
  
)

export default component.exports